const submittedDocumentDeterminationStatus = {
  NoSometido: 1,
  Sometido: 2,
  Aprobado: 3,
  Denegado: 4,
};

export default submittedDocumentDeterminationStatus;
